import {
    Base64
} from 'js-base64'
import md5 from 'js-md5';
import {
    Modal,
    message
} from "ant-design-vue";
import {
    createVNode
} from "vue";
import {
    ExclamationCircleOutlined
} from "@ant-design/icons-vue";

export default {
    /**
     * 写入缓存
     * @param name
     * @param value
     */
    setStorage(name, value) {
        localStorage.setItem(name, value)
    },
    /**
     * 读取缓存
     * @param name
     * @returns {string}
     */
    getStorage(name) {
        return localStorage.getItem(name)
    },
    /**
     * 删除缓存
     * @param name
     */
    removeStorage(name) {
        localStorage.removeItem(name)
    },
    /**
     * 写入session缓存
     * @param name
     * @param value
     */
    setSessionStorage(name, value) {
        sessionStorage.setItem(name, value)
    },
    /**
     * 读取session缓存
     * @param name
     * @returns {string}
     */
    getSessionStorage(name) {
        return sessionStorage.getItem(name)
    },
    /**
     * 弹出提示消息
     * @param type
     * @param str
     * @param times
     * @param funds
     * @returns {*}
     */
    message(type, str, times = 3, funds = null) {
        return message[type](str, times, funds)
    },
    /**
     * 获取url 参数
     * @returns {{}}
     */
    get_query() {
        let query = {};
        let search = location.search
        if (search.length > 2) {
            search = search.split('?')[1].split('&')
            for (let i = 0; i < search.length; i++) {
                let arr = search[i].split('=');
                if (arr.length === 2) {
                    query[arr[0]] = arr[1]
                }
            }
        }
        return query
    },
    /**
     * 特殊Base64加密
     * @param value
     * @returns {string}
     */
    setBase64(value) {
        if (value) {
            let text = this.generateRandomString()
            return text + Base64.encode(value);
        }
    },
    /**
     * 解析特殊Base64加密
     * @param value
     * @returns {string}
     */
    getBase64(value) {
        if (value) {
            let newValue = value.slice(10)
            return Base64.decode(newValue);
        }
    },
    /**
     * 生成随机字符串
     * @param digit
     * @returns {string}
     */
    generateRandomString(digit = 10) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for (let i = 0; i < digit; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    },
    /**
     * 进行md5加密
     * @param value
     * @returns {*}
     */
    setMd5Data(value) {
        return md5(value).toLowerCase()
    },
    /**
     * 删除及修改状态的方法-封装
     * @param data
     * @param apiName
     * @param where
     * @returns {Promise<unknown>}
     */
    operationFun(data = {
        toast: true,
        cancelText: '取消',
        okText: '确定',
        type: 'confirm'
    }, apiName = null, where = {}) {
        let modalType = ['confirm', 'info', 'success', 'warning', 'error']
        data.toast = data.hasOwnProperty('toast') ? data.toast : true
        data.cancelText = data.hasOwnProperty('cancelText') ? data.cancelText : '取消'
        data.okText = data.hasOwnProperty('okText') ? data.okText : '确定'
        data.type = data.hasOwnProperty('type') && modalType.indexOf(data.type) != -1 ? data.type : 'confirm'
        return new Promise((resolve, reject) => {
            Modal[data.type]({
                content: data.content,
                title: data.title,
                icon: createVNode(ExclamationCircleOutlined),
                okText: data.okText,
                cancelText: data.cancelText,
                onOk() {
                    if (apiName) {
                        apiName({
                            data: {
                                ...where
                            },
                            toast: data.toast
                        }).then((res) => {
                            resolve(res)
                        })
                    } else {
                        resolve()
                    }
                },
                onCancel() {
                    reject()
                },
            });
        })
    },

}